import { useState } from 'react';
import { Close } from '@styled-icons/remix-line';

import theme from 'styles/theme';
import Tabs from '../Tabs';
import LineChart, { LineChartProps } from '../LineChart';
import ComparisonTable, { ComparisonTableTypes } from '../ComparisonTable';
import InfoMessage from '../InfoMessage';

import * as S from './styles';

enum ComparisonTabs {
  COMPARISON = '1',
  SEE_SAVINGS = '2',
}

export type ComparisonModalProps = {
  tableData: ComparisonTableTypes;
  chartData: LineChartProps;
  open: boolean;
  closeModal: () => void;
};

const ComparisonModal = ({
  open,
  tableData,
  chartData,
  closeModal,
}: ComparisonModalProps) => {
  const [activeTab, setActiveTab] = useState<string>(ComparisonTabs.COMPARISON);

  return (
    <S.Modal
      centered
      footer={null}
      onCancel={closeModal}
      open={open}
      width={842}
      closeIcon={
        <S.CloseButton>
          <Close size={18} color={theme.colors.neutralSilver50} />
        </S.CloseButton>
      }
    >
      <S.Tabs>
        <Tabs
          onTabChange={(tab) => setActiveTab(tab)}
          tabs={[
            {
              title: 'Compare',
              index: '1',
            },
            {
              title: 'See the savings',
              index: '2',
            },
          ]}
        />
      </S.Tabs>
      <S.Content>
        {activeTab === ComparisonTabs.COMPARISON ? (
          <>
            <ComparisonTable {...tableData} />
            <S.InfoMessageContainer>
              <InfoMessage
                variant="warning"
                text="EAPR is different than APR. It’s not interest rate, it reflects in our monthly admin. fees and stays the same throughout the contract term."
              />
            </S.InfoMessageContainer>
          </>
        ) : (
          <LineChart {...chartData} />
        )}
      </S.Content>
    </S.Modal>
  );
};

export default ComparisonModal;
